export default "__VITE_ASSET__b87ed427__"